import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { AutomationsApiProvider } from "./api/automations-api-provider";

/**
 * Mounted at developer/automations. Open to every team; only the Developer
 * section's allowlist decides whether the side nav and search show it.
 */
export const automationsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Automations" },
    element: <AutomationsApiProvider />,
    children: [
      {
        index: true,
        async lazy() {
          const { AutomationsPage } = await import("./list/automations-page");
          return { Component: AutomationsPage };
        },
      },
      {
        // One route for the editor and its runs, so moving between them keeps the editor open.
        path: ":automationId/*",
        handle: { breadcrumb: "Automation" },
        async lazy() {
          const { AutomationEditorPage } = await import("./editor/editor-page");
          return { Component: AutomationEditorPage };
        },
      },
    ],
  },
];
